import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterItem } from "../utils/models";
import { formatTime } from "../utils/utilities";

interface ProjectQueryState {
    inspectionTypeId?: string;
    startDate?: string;
    endDate?: string;
    limit?: number;
    page?: number;
    searchFields?: FilterItem[];
    projectStatus?: string[];
}

const initialState: ProjectQueryState = {
    limit: 50,
};

const slice = createSlice({
    name: 'projectsQuery',
    initialState,
    reducers: {
        setStartDate: (state, action: PayloadAction<Date | undefined>) => {
            state.startDate = action.payload ? formatTime(action.payload, 'YYYY-MM-DD') : undefined;
        },
        setEndDate: (state, action: PayloadAction<Date | undefined>) => {
            state.endDate = action.payload ? formatTime(action.payload, 'YYYY-MM-DD') : undefined;
        },
        setInspectionType: (state, action: PayloadAction<string>) => {
            state.inspectionTypeId = action.payload;
        },
        setFilters: (state, action: PayloadAction<FilterItem[]>) => {
            state.searchFields = action.payload;
        },
        setLimit: (state, action: PayloadAction<number>) => {
            state.limit = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setProjectStatus: (state, action: PayloadAction<string>) => {
            const status = action.payload;

            if (state.projectStatus && state.projectStatus.includes(status)) {
                state.projectStatus =  state.projectStatus.filter((projectStatus) => projectStatus !== status);
            } else {
                state.projectStatus = state.projectStatus ? [...state.projectStatus, status] : [status];
            }
        },
         resetProjectStatus: (state) => {
            state.projectStatus = undefined
        },
    }
});

export const {  setLimit, setProjectStatus, setFilters, setPage, setInspectionType, setStartDate, setEndDate, resetProjectStatus } = slice.actions;
export default slice.reducer;